import React from 'react';
import { AvoidanceZoneBox } from './avoidance-zone-box';
import { HereMapHeading } from './here-map-heading';
import { HereMapSpeed } from './here-map-speed';
import { type AvoidanceZone, type DeviceLocation } from '../../types';

interface UseHereMapBaseContentProps {
    deviceLocations?: DeviceLocation[];
    trailerDeviceLocations?: DeviceLocation[];
    avoidanceZones: AvoidanceZone[];
}

export const useHereMapBaseContent = (props: UseHereMapBaseContentProps) => {
    const { deviceLocations, trailerDeviceLocations, avoidanceZones } = props;
    
    const [deviceHeadings, setDeviceHeadings] = React.useState<React.ReactNode>(null);
    const [mappedDeviceLocations, setMappedDeviceLocations] = React.useState<(number | null)[][]>([]);
    React.useEffect(() => {
        const waypoints = deviceLocations?.map(location => [location.latitude, location.longitude, null]);
        setMappedDeviceLocations(waypoints || []);

        const heading = deviceLocations?.map((location, i) => {
            return (
                <>
                    <HereMapHeading key={`mobile${i}`} location={location} type={'mobile'} />
                    <HereMapSpeed key={`speed${i}`} location={location} />
                </>
            );
        });
        setDeviceHeadings(heading);
    }, [deviceLocations]);

    const [trailerHeadings, setTrailerHeadings] = React.useState<React.ReactNode>(null);
    const [mappedTrailerLocations, setMappedTrailerLocations] = React.useState<(number | null)[][]>([]);
    React.useEffect(() => {
        const waypoints = trailerDeviceLocations?.map(location => [location.latitude, location.longitude, null]);
        setMappedTrailerLocations(waypoints || []);

        const heading = trailerDeviceLocations?.map((location, i) => {
            return (<HereMapHeading key={i} location={location} type={'trailer'} />);
        });
        setTrailerHeadings(heading);
    }, [trailerDeviceLocations]);

    //Im unsure this is right, especially when dealing with carriers and when they see whos avoidance zones.
    //different screens need to show avoidance zones differently, especially when if/when logged in as a carrier
    const filteredAvoidanceZones = avoidanceZones.filter(x => !x.deactivatedAt);
    const avoidanceZoneBoxes = filteredAvoidanceZones?.map((x, i) =>
        <AvoidanceZoneBox key={i} avoidanceZone={x} />
    );

    return {
        deviceHeadings,
        mappedDeviceLocations,
        trailerHeadings,
        mappedTrailerLocations,
        filteredAvoidanceZones,
        avoidanceZoneBoxes
    }
}